import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import moment from "moment";
import OrderItem from "components/OrderItem";
import CautionBox from "components/CautionBox";
import FormatDateWithLocale from "components/FormatDateWithLocale";
import { ORDER_TYPE } from "constants/index";
import { ORDER_STATUS } from "constants/status";
import { getOrders } from "api";
import { useFormattedMessage, useSideModalScrollToTop } from "hooks";
import { selectUserId } from "store/user/account/selectors";
import { selectProjectDetails } from "store/project/selectors";
import NewLoader from "components/NewLoader";

const messages = {
    soMainHeading: "active_purchase_offer",
    soHeading: "purchase_offers",
    soContent: "sell_your_shares_content",
    soMoreOffers1: "load",
    soSingleMoreOffers2: "more_purchase_offer",
    soMoreOffers2: "so_more_purchase_offers",
    soOTPMainHeading: "create_sales_order",
    soCreateContent: "create_own_sell",
    soButtonText: "create_sell_order",
    notEnoughWalletBalance: "not_enough_wallet_balance",
    noActiveOffers: "no_active_offers",
    notEnoughUserShares: "not_enough_user_shares",
};

const SellOrders = ({
    className = "",
    onCreateButtonClick,
    onAcceptOffer,
    setCloseTitle,
    setOfferAccepted,
    getBuyOrders = false,
    project,
    userUid,
    userProjectShares,
    isUserProjectShares,
    backSlideEffect = "",
    allProjects,
    minShareTypeWise,
}) => {
    useSideModalScrollToTop();

    const { formatMessage } = useFormattedMessage();

    const [isBuyOrdersLoading, setBuyOrdersLoading] = useState(false);
    const [buyOrders, setBuyOrders] = useState([]);
    const [orderLimit, setOrderLimit] = useState(3);

    const isCreateButtonDisable = parseInt(userProjectShares) < minShareTypeWise ? true : false;
    const projectID = project && project.projectID;

    useEffect(() => {
        setCloseTitle(formatMessage(messages.soMainHeading));
        setOfferAccepted(false);
    }, []);

    async function fetchBuyOrders(type) {
        try {
            setBuyOrdersLoading(true);
            const response = await getOrders({ projectID, type });
            response && setBuyOrdersLoading(false);
            if (response?.data?.data?.orders?.orders) {
                const filterOrders = response.data.data.orders.orders.filter(
                    (x) => x.LinkBuyer !== userUid && x.StatusOrder === ORDER_STATUS.ACTIVE
                );
                setBuyOrders(filterOrders.sort((a, b) => parseFloat(b.SharePrice) - parseFloat(a.SharePrice)));
            }
        } catch (error) {
            /* error */
        }
    }

    useEffect(() => {
        getBuyOrders && fetchBuyOrders(ORDER_TYPE.BUY);
    }, [getBuyOrders]);

    const singleProject = (id) => allProjects?.find((item) => item.projectID === id) || {};

    return (
        <>
            {isUserProjectShares ? (
                <NewLoader type="primary" className="editable-modal-loader" />
            ) : (
                <div className={`sell-orders-container ${className} ${backSlideEffect}`}>
                    <h3>{formatMessage(messages.soHeading)}</h3>
                    <p>{formatMessage(messages.soContent)}</p>
                    <form method="post">
                        <div className="custom-checks sell-orders">
                            {isBuyOrdersLoading ? (
                                <NewLoader type="primary" className="center" />
                            ) : Array.isArray(buyOrders) && buyOrders.length > 0 ? (
                                buyOrders
                                    .slice(0, orderLimit)
                                    .map(
                                        (
                                            {
                                                uid,
                                                Shares,
                                                AvailableShares,
                                                SharePrice,
                                                Amount,
                                                IsSplitAllowed,
                                                ExpirationDate,
                                                LinkProduct,
                                                UserCountry,
                                                TypeOrder,
                                                SoldShares,
                                                SharesInProgress,
                                            },
                                            index
                                        ) => {
                                            const project = singleProject(LinkProduct?.ProductID);
                                            const isDisable =
                                                IsSplitAllowed === "true"
                                                    ? parseInt(userProjectShares) < minShareTypeWise
                                                    : parseInt(userProjectShares) < parseInt(Shares);

                                            return (
                                                <>
                                                    <OrderItem
                                                        key={index}
                                                        equalTitle={false}
                                                        orderFlag={UserCountry}
                                                        className={isDisable ? "disable" : ""}
                                                        tag={
                                                            IsSplitAllowed === "true"
                                                                ? `split-${TypeOrder.replace(ORDER_TYPE.BUY, ORDER_TYPE.SELL)}`
                                                                : TypeOrder.replace(ORDER_TYPE.BUY, ORDER_TYPE.SELL)
                                                        }
                                                        onClickModal={() => {
                                                            onAcceptOffer({
                                                                uid,
                                                                flag: UserCountry,
                                                                tag:
                                                                    IsSplitAllowed === "true"
                                                                        ? `split-${TypeOrder.replace(
                                                                              ORDER_TYPE.BUY,
                                                                              ORDER_TYPE.SELL
                                                                          )}`
                                                                        : TypeOrder.replace(ORDER_TYPE.BUY, ORDER_TYPE.SELL),
                                                                split: !!(
                                                                    IsSplitAllowed === "true" &&
                                                                    parseInt(AvailableShares) >= minShareTypeWise * 2
                                                                ),
                                                                image: project?.images?.teaserImage?.path,
                                                                title: project?.title,
                                                                city: project?.address?.city,
                                                                shares: AvailableShares,
                                                                price: parseFloat(Amount),
                                                                date: moment(new Date(ExpirationDate?.split("_")[0])).format(
                                                                    "YYYY-MM-DD"
                                                                ),
                                                                pricePerShare: SharePrice,
                                                            });
                                                        }}
                                                        isOrderSplit={IsSplitAllowed === "true"}
                                                        split={
                                                            !!(
                                                                IsSplitAllowed === "true" &&
                                                                parseInt(AvailableShares) >= minShareTypeWise * 2
                                                            )
                                                        }
                                                        image={project?.images?.teaserImage?.path}
                                                        title={project?.title}
                                                        // city={project?.address?.city}
                                                        shares={Shares}
                                                        remainingShares={AvailableShares}
                                                        soldShares={IsSplitAllowed === "true" ? SoldShares : null}
                                                        reservedShares={IsSplitAllowed === "true" ? SharesInProgress : null}
                                                        price={parseFloat(Amount)}
                                                        date={<FormatDateWithLocale date={ExpirationDate?.split("_")[0]} />}
                                                        perSharePrice={SharePrice}
                                                    />
                                                    {isDisable ? (
                                                        <span className="text-12 alert-red-color">
                                                            {formatMessage(messages.notEnoughUserShares)}
                                                        </span>
                                                    ) : null}
                                                </>
                                            );
                                        }
                                    )
                            ) : (
                                <CautionBox text={formatMessage(messages.noActiveOffers)} />
                            )}
                        </div>
                        {!isBuyOrdersLoading && buyOrders?.length > orderLimit ? (
                            <span
                                onClick={() => setOrderLimit(buyOrders.length)}
                                className="text-14 fw-600 load-more secondary-light-color"
                            >{`${formatMessage(messages.soMoreOffers1)} ${buyOrders.length - orderLimit} ${
                                buyOrders.length - orderLimit === 1
                                    ? formatMessage(messages.soSingleMoreOffers2)
                                    : formatMessage(messages.soMoreOffers2)
                            }`}</span>
                        ) : null}
                    </form>
                    <div className="border-x my-10" />
                    <div className="create-sell-order">
                        <h4 className="mt-0">{formatMessage(messages.soOTPMainHeading)}</h4>
                        <p>{formatMessage(messages.soCreateContent)}</p>
                        <button
                            className={`mw-100 mt-10 red ${isCreateButtonDisable ? "disable-grey" : ""}`}
                            disabled={isCreateButtonDisable}
                            onClick={onCreateButtonClick}
                        >
                            {formatMessage(messages.soButtonText)}
                        </button>
                        {isCreateButtonDisable ? (
                            <span className="text-12 alert-red-color">{formatMessage(messages.notEnoughUserShares)}</span>
                        ) : null}
                    </div>
                </div>
            )}
        </>
    );
};

const mapStateToProps = createStructuredSelector({
    userUid: selectUserId,
    allProjects: selectProjectDetails,
});

export default connect(mapStateToProps)(SellOrders);
